var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"list__row"},[_c('span',{directives:[{name:"popover",rawName:"v-popover:transfer-operation",arg:"transfer-operation"}],class:_vm.rowCss,on:{"click":_vm.showTransferInfo}},[_vm._v("\n    "+_vm._s(_vm.record.operation_name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c148b54e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/stock/features/stock-movement/OperationNameRow.vue
// module id = null
// module chunks = 